<template>
  <div v-loading="loginLoading" element-loading-text="Loading" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div class="login">
      <div class="left">
        <!-- :arrow="nerver" -->
        <el-carousel height="610px" :autoplay="false">
          <!-- <el-carousel-item v-for="(item, index) in items" :key="index"> -->
          <h3 class="small">{{ items[0].p }}</h3>
          <div class="bg" :style="{
              backgroundImage: items[0].backgroundImage,
            }"></div>
          <!-- </el-carousel-item> -->
        </el-carousel>
      </div>
      <div class="right">
        <h5></h5>
        <p>欢迎登录智能配电监控云平台</p>
        <el-form :label-position="'top'" label-width="80px" :model="formData">
          <el-form-item label="账号">
            <el-input v-model="formData.username" placeholder="请输入您的账号" @keyup.enter.native="submitForm"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="formData.password" type="password" placeholder="请输入您的密码" autocomplete="off" show-password
              @keyup.enter.native="submitForm"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login_btn" @click="submitForm()">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <p class="copyright">
      <!-- © 2020-2021
      <a href="http://www.createdpark.com/">恒泰宏科科技有限公司</a>
      版权所有
      <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备20009764号-3</a>
      <span class="copy-line">|</span>--> <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备20009764号-3</a> |
      系统版本号：v0.2.0
      <!-- <span class="copy-line">|</span> 推荐浏览器（<a href="http://browser.360.cn/">360极速浏览器</a>,<a href="https://www.google.cn/chrome/">谷歌浏览器</a>） -->
    </p>
  </div>
</template>

<script>
  import { Message } from "element-ui";
  export default {
    name: "login",
    data () {
      return {
        formData: {
          username: "",
          password: "",
        },
        loginLoading: false,
        items: [
          {
            p: "智能配电监控云平台",
            backgroundImage:
              "url(" + require("../assets/images/login1.png") + ")",
          },
          // {
          //   p: "智能配电监控云平台",
          //   backgroundImage:
          //     "url(" + require("../assets/images/login1.png") + ")",
          // },
        ],
      };
    },
    created () { },
    methods: {
      submitForm () {
        if (this.formData.username == "") {
          Message("请输入账号");
          return;
        }
        if (this.formData.password == "") {
          Message("请输入密码");
          return;
        }
        this.loginLoading = true;
        this.$http
          .post("/bma-auth-service/sys/signIn", this.formData)
          .then((res) => {
            if (res.code === 200) {
              this.getCode();
              localStorage.stop = false;
            } else {
              this.loginLoading = false;
            }
          });
      },
      getCode () {
        this.$http
          .post("/bma-auth-service/oauth2/getCode", {
            clientId: "devops",
            clientSecret: "hengtaidevops",
          })
          .then((res2) => {
            if (res2.code === 200) {
              console.log(res2);
              this.getToken(res2.data);
            } else {
              this.loginLoading = false;
            }
          });
      },
      getToken (code) {
        this.$http
          .post("/bma-auth-service/oauth2/getToken", {
            clientId: "devops",
            clientSecret: "hengtaidevops",
            code: code,
          })
          .then((res) => {
            if (res.code === 200) {
              document.cookie = "token=" + res.data.accessToken;
              document.cookie = "refreshToken=" + res.data.refreshToken;
              document.cookie = "comeTime=" + new Date().getTime();
              this.getUserInfo(res.data.accessToken);
            } else {
              this.loginLoading = false;
            }
          });
      },
      getProjectUnHandleByUser (userID) {
        this.totalNum = 0;
        this.initArr = [];
        this.$http
          .post("bma-user-service/user/getProjectUnHandleByUser", {
            userId: userID,
          })
          .then((res) => {
            if (res.code === 200) {
              let projectHandles = res.data.projectHandles;
              if (projectHandles.length > 0) {
                this.initArr = projectHandles;
                projectHandles.forEach((item) => {
                  console.log("得到的数据" + item.unHandle);
                  this.totalNum += item.unHandle;
                });
              } else {
                this.totalNum = 0;
                this.initArr = [];
              }
              this.$store.commit("setTotalNum", this.totalNum);
            } else {
              this.loginLoading = false;
            }
          });
      },
      getlist (userId) {
        this.$http
          .post("bma-user-service/user/web/searchRoleResourcesByUserForWeb", {
            userId: userId,
          })
          .then((res) => {
            console.log("列表信息", res);
            let resourceIds = [];
            let menuSon = [];
            if (res.data && res.data.length > 0) {
              res.data[0].children.forEach((item) => {
                if (item.resourceId === 3) {
                  item.children.forEach((son) => {
                    menuSon.push(son.resourceId);
                  });
                }
                resourceIds.push(item.resourceId);
              });
            }
            console.log(menuSon);
            // 要求强制刷新时，菜单也存在
            localStorage.menuSon = menuSon;
            // this.$store.commit("setMenuChildren", menuSon);
            document.cookie = "resourceIds=" + resourceIds;
            this.resourceLists = resourceIds;
          });
      },
      getUserInfo (token) {
        this.$http
          .post("/bma-auth-service/oauth2/getUserInfo")
          .then((res) => {
            if (res.code === 200) {
              document.cookie = "userInfo=" + JSON.stringify(res.data);
              this.$store.commit("setUserInfo", res.data);
              this.roundIds(res.data, res.data.userId);
              const access_token = token;
              this.getProjectUnHandleByUser(res.data.userId);
              this.loginLoading = false;
              setTimeout(() => {
                this.$initWebSocket();
              }, 2000);
              // window.location.href='http://localhost:8080/#/project'
              // setInterval(this.sixGetInfo,  6*3600 * 1000);
              if (res.data.projectTopic) {
                this.$router.push("/project");
                localStorage.code =
                  res.data.projectTopic.length > 0
                    ? res.data.projectTopic[0].projectCode
                    : "";
              } else {
                this.$router.push("/super");
              }
            } else {
              this.loginLoading = false;
            }
          })
          .catch((error) => {
            this.loginLoading = false;
            console.log("error: ", error);
          });
      },
      roundIds (data, userId) {
        let num = 0;
        if (data.projectTopic) {
          // alert('有')
          data.projectTopic.forEach((item) => {
            num++;
            item.id = num;
          });
        } else {
          // alert('没有')
          this.getlist(userId);
          this.$router.push("/super");
          // return false
        }
        // console.log(data)
      },
      sixGetInfo () {
        // alert("执行了、");
        this.$http
          .post("/bma-auth-service/oauth2/refreshToken", {
            clientId: "devops",
            clientSecret: "hengtaidevops",
            refreshToken: this.$getCookie("refreshToken"),
          })
          .then((res2) => {
            if (res2.code === 200) {
              this.$cookies.set("token", res2.data.accessToken, {
                expires: 365,
              });
              this.$cookies.set("refreshToken", res2.data.refreshToken, {
                expires: 365,
              });
            } else {
              this.$router.push("/");
            }
          })
          .catch(function (err) {
            this.$router.push("/");
          });
      },
    },
  };
</script>

<style lang="less" scoped>
  .login {
    width: 100vw;
    height: 100vh;
    background: #000;
    display: flex;
    box-sizing: border-box;
    padding: 180px;
    align-items: center;

    .left {
      width: 1032px;
      height: 610px;

      h3 {
        color: #ffffff;
        font-size: 42px;
        letter-spacing: 8px;
      }

      .bg {
        width: 100%;
        height: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
      }
    }

    .right {
      width: 528px;
      height: 535px;
      background: #fff;
      box-sizing: border-box;
      padding: 44px;

      h5 {
        font-size: 24px;
        font-weight: 600;
        margin: 36px 0;
        width: 523px;
      }

      p {
        font-size: 22px;
        color: #000;
        font-weight: 600;
        margin-top: 45px;
      }

      /deep/.el-form {
        margin-top: 40px;

        .el-input {
          .el-input__inner {
            background: #fafafa;
          }
        }
      }

      .login_btn {
        margin-top: 45px;
        width: 132px;
        height: 42px;
      }
    }
  }

  .copyright {
    margin-top: -35px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #a6a6a6;

    a {
      color: #a6a6a6;
    }

    a:hover {
      color: #fff;
    }

    .copy-line {
      padding: 0 20px;
    }
  }
</style>